var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _vm.mainTable.brandShow
            ? _c(
                "Row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c("search-card", {
                        attrs: {
                          form: _vm.mainTable.brandForm,
                          "table-load-event": _vm.getMainTableRecords,
                          "table-search": _vm.mainTable.tableSearch,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "Card",
        [
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c("Col", { attrs: { span: "24" } }, [
                _c("div", { staticClass: "global-tool-bar" }, [
                  _c("div", { staticClass: "left-bar" }, [
                    _c("span", { staticClass: "title" }, [_vm._v("品牌管理")]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "right-bar" },
                    [
                      _vm.$checkAccessArray(["S"])
                        ? _c(
                            "Button",
                            {
                              staticClass: "btns",
                              attrs: {
                                size: "small",
                                shape: "circle",
                                type: "success",
                                icon: "ios-add-circle-outline",
                              },
                              on: { click: _vm.onCreate },
                            },
                            [_vm._v("新增")]
                          )
                        : _vm._e(),
                      _c(
                        "Button",
                        {
                          staticClass: "btns",
                          attrs: {
                            type: "primary",
                            size: "small",
                            shape: "circle",
                            icon: "ios-search",
                          },
                          on: {
                            click: function ($event) {
                              _vm.mainTable.brandShow = !_vm.mainTable.brandShow
                            },
                          },
                        },
                        [_vm._v("搜索")]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _vm.formShow
                    ? _c(
                        "Form",
                        {
                          ref: "brandForm",
                          staticClass: "small-form border",
                          attrs: {
                            model: _vm.form,
                            rules: _vm.ruleValidate,
                            "label-position": "top",
                          },
                        },
                        [
                          _c(
                            "Row",
                            { attrs: { gutter: 16 } },
                            [
                              _c(
                                "Col",
                                { attrs: { span: "6" } },
                                [
                                  _c(
                                    "FormItem",
                                    {
                                      attrs: {
                                        label: "品牌名称",
                                        prop: "brandName",
                                      },
                                    },
                                    [
                                      _c("Input", {
                                        model: {
                                          value: _vm.form.brandName,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.form, "brandName", $$v)
                                          },
                                          expression: "form.brandName",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "4" } },
                                [
                                  _c(
                                    "FormItem",
                                    {
                                      attrs: {
                                        label: "所属苗场",
                                        prop: "seedFarmName",
                                      },
                                    },
                                    [
                                      _c("Input", {
                                        model: {
                                          value: _vm.form.seedFarmName,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "seedFarmName",
                                              $$v
                                            )
                                          },
                                          expression: "form.seedFarmName",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "4" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "主图" } },
                                    [
                                      _c("single-file-upload-with-name", {
                                        model: {
                                          value: _vm.form.brandMainImageFile,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "brandMainImageFile",
                                              $$v
                                            )
                                          },
                                          expression: "form.brandMainImageFile",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "4" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "缩图" } },
                                    [
                                      _c("single-file-upload-with-name", {
                                        model: {
                                          value: _vm.form.brandThumbnailFile,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "brandThumbnailFile",
                                              $$v
                                            )
                                          },
                                          expression: "form.brandThumbnailFile",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Row",
                            { attrs: { gutter: 16 } },
                            [
                              _c(
                                "Col",
                                { attrs: { span: "6" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "备注" } },
                                    [
                                      _c("Input", {
                                        model: {
                                          value: _vm.form.brandRemark,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "brandRemark",
                                              $$v
                                            )
                                          },
                                          expression: "form.brandRemark",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Row",
                            [
                              _c(
                                "Col",
                                { attrs: { span: "24" } },
                                [
                                  _vm.$checkAccessArray(["S"])
                                    ? _c(
                                        "Button",
                                        {
                                          attrs: { type: "success" },
                                          on: { click: _vm.onSave },
                                        },
                                        [
                                          _vm._v(
                                            "保存\n                        "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _c(
                                    "Button",
                                    {
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          _vm.formShow = false
                                        },
                                      },
                                    },
                                    [_vm._v("取消\n                        ")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _c("stand-pagination-table", {
                    attrs: {
                      columns: _vm.mainTable.tableColumns,
                      data: _vm.mainTable.tableData,
                      loading: _vm.mainTable.tableLoading,
                      "table-search": _vm.mainTable.tableSearch,
                      "table-load-event": _vm.getMainTableRecords,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }